import React, { useEffect } from 'react';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { useLocalStorage, GlobalKeys, ConsentValue } from 'helpers/localStorage';
import { setDatadogTrackingConsent } from 'utils/initDatadogRum';
import './CookieConsentBanner.scss';

const CookieConsentBanner = () => {
    const [consent, setConsent] = useLocalStorage<ConsentValue | null>(GlobalKeys.CookieConsent, null);

    useEffect(() => {
        if (consent) {
            setDatadogTrackingConsent(consent);
        }
    }, [consent]);

    const handleAccept = () => setConsent(ConsentValue.Granted);
    const handleDecline = () => setConsent(ConsentValue.NotGranted);

    if (consent) return null;

    return (
        <div
            className="CookieConsentBanner fixed-bottom d-flex align-items-center gap-3 justify-content-center py-3 px-4 pr-2"
            role="region"
            aria-label="Cookie consent notice"
        >
            <p className="mb-0 mr-2">
                We use cookies and similar technologies to improve your experience,
                analyze site usage, and assist in our marketing efforts.
            </p>
            <div className="d-flex">
                <NSButtonBase
                    color="secondary"
                    outline
                    text="Reject all"
                    callback={handleDecline}
                    className="ml-2"
                />
                <NSButtonBase
                    color="primary"
                    text="Allow all"
                    callback={handleAccept}
                    className="ml-2"
                />
            </div>
        </div>
    );
};

export default CookieConsentBanner;
